// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/allproducts/azelite3.jpg";
import thumb1 from "../assets/images/New-Products/Azelite.jpg";
import thumb2 from "../assets/images/allproducts/azelite3.jpg";
import thumb3 from "../assets/images/New-Products/Azelite2.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Azelite</h2>
              <p className="sub-heading">10% Azelaic acid with probiotics</p>
              <h5>Product Overview</h5>
              <p>
                Creamy, lightweight emulsion formulated with a potent level of pure azelaic acid, a bioactive brightening complex,
                and niacinamide to help calm visible redness while minimizing the look of uneven tone and texture.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Azelite?</span>
                </h3>
                <p>
                  Apply to effected area/face & neck once or twice a day. Dosage as per skin’s tolerability or as guided by physician
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Azelite Cream addresses four major skin concerns: acne, rosacea, hyperpigmentation & dark spots, and photodamage/photoaging.</li>
                    <li>Suitable for all skin types including dry, combination, and oily skin.</li>
                    <li>Balances excess oil.</li>
                    <li>Brightens and lightens hyperpigmented skin with age spots and freckles.</li>
                    <li>Lightens post-acne marks, dark spots, and age spots.</li>
                    <li>Maintains normal skin pH around 4.0 to 5.0.</li>
                    <li>Targets uneven skin tone and texture.</li>
                    <li>Lightens pigmentation.</li>
                    <li>Calms visible redness and inflammation.</li>
                    <li>Provides antioxidant, anti-inflammatory, and anti-aging benefits.</li>
                    <li>Provides hydration and moisturization to the skin.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Cleanse your face with a non-comedogenic face wash.</li>
                      <li>Pump out an adequate quantity of cream and apply it evenly on the face.</li>
                      <li>Apply once daily at night for better results.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Azelaic Acid 10%:</strong> Azelaic acid is a gold-standard ingredient for treating acne, rosacea, and hyperpigmentation.
                      </li>

                      <li>
                        <strong>Hydroxy Propanoic Acid (Lactic Acid):</strong> Helps maintain the product’s pH without disrupting the skin’s natural pH. A gentle acid suitable for sensitive skin with hydrating and exfoliating properties. It also enhances penetration and absorption of Azelaic acid.
                      </li>

                      <li>
                        <strong>Probiotics (Bifidobacterium):</strong> Play a crucial role as Azelite contains mild AHAs. Probiotics form a thin biofilm on the skin that acts as a Natural Moisturizing Factor (NMF), controlling hydration and moisturization levels without affecting the skin’s natural microflora.
                      </li>

                      <li>
                        <strong>Niacinamide 3%:</strong> Offers anti-aging and depigmenting benefits by blocking melanosome transfer. Helps control sebum production and provides anti-inflammatory effects.
                      </li>

                      <li>
                        <strong>Zinc PCA (Pyrrolidone Carboxylic Acid):</strong> Combines the benefits of Zinc and PCA—an essential part of the skin’s Natural Moisturizing Factor. Helps reduce sebum secretion, inhibits acne-causing bacteria, and gives the skin a fresh, healthy feel.
                      </li>

                      <li>
                        <strong>Tazman Pepper:</strong> An anti-inflammatory active that soothes and calms reactive skin. Inhibits TRPV1 discomfort sensors and reduces inflammatory markers like IL-1a, IL-8, and PGE2. Instantly relieves itching, burning, redness, and erythema.
                      </li>

                      <li>
                        <strong>Arbutin 2%:</strong> Inhibits the tyrosinase enzyme and provides antioxidant benefits to help lighten pigmentation.
                      </li>

                      <li>
                        <strong>Kakadu Plum:</strong> Extracted from the Kakadu plum fruit, a rich source of Vitamin C. Provides antioxidant, anti-inflammatory, anti-aging, and antibacterial benefits, promoting mature and blemish-free skin.
                      </li>
                    </ul>

                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
